/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useChannelsList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const ChannelSelect = React.forwardRef(({ placeholder = 'Type to search channel', children, ...props }, ref) => (
  <SearchableEntitySelect
    formatLabel={({ title }) => title}
    placeholder={placeholder}
    useList={useChannelsList}
    {...props}
    ref={ref}
  />
));

export default ChannelSelect;
